import { Fragment, useCallback, useEffect, useState } from 'react';

import NibAsyncAutoComplete from '../NibAsyncAutoComplete/NibAsyncAutoComplete';
import { NibCardItem as CardItem } from '../NibCard';

const InputAutocomplete = ({
  initLoad = false,
  required = false,
  onChange = false,
  name,
  placeholder,
  label,
  helperText,
  tools = ['info'],
  onAdd = () => {},
  updateData = false,
  formik,
  onlyInput = false,
  ...props
}) => {
  const [isHelper, toggleHelper] = useState(false);
  const [isDataLoading, setDataLoading] = useState(false);
  const [data, setData] = useState([]);

  const handleInput = async (val) => {
    formik.setFieldTouched(name);
    if (updateData) {
      setDataLoading(true);
      let data = await updateData(val);
      setData(data.length ? data : []);
      setDataLoading(false);
    }
  };

  const handleChange = (val) => {
    formik.setFieldValue(name, val);
    if (onChange) {
      onChange(val);
    }
  };

  const getNestedError = (fieldName) => {
    return fieldName.split('.').reduce((acc, key) => (acc && acc[key] ? acc[key] : null), formik.errors);
  };

  const formikError = getNestedError(name);

  const getOptions = useCallback(() => {
    const hasValue = formik.values[name] && formik.values[name] !== null;
    if (hasValue && !initLoad) {
      return [
        {
          id: formik.values[name].id,
          name: formik.values[name].name,
        },
        ...data,
      ];
    }
    return data;
  }, [data, formik]);

  useEffect(() => {
    if (initLoad) {
      handleInput('');
    }
  }, [initLoad]);

  const input = (
    <NibAsyncAutoComplete
      error={formik.touched[name] && !!formikError}
      options={getOptions()}
      loading={isDataLoading}
      value={formik.values[name]}
      handleInput={handleInput}
      onChange={handleChange}
      placeholder={placeholder}
      helperText={isHelper && helperText}
      {...props}
    />
  );

  const labelText = (
    <Fragment>
      {label} {required && <i>*</i>}
    </Fragment>
  );

  if (onlyInput) return input;
  return (
    <CardItem name={label ? labelText : null} btns={tools} onInfo={() => toggleHelper(!isHelper)}>
      {input}
      {formik.touched[name] && formikError && (
        <p className={'customErrorMsg'}>
          {typeof formikError === 'string'
            ? formikError
            : formikError.name || formikError.value || 'This field is required'}
        </p>
      )}
    </CardItem>
  );
};

export default InputAutocomplete;
